module.exports = __webpack_public_path__ + "static/em_capabilities_3_2-747fe6ae871dd545e4c543a81ef184e6.png";